import * as React from 'react';
import { ContextData, Reducer } from '../types';

const contextProviders: React.ComponentType<{ children: React.ReactElement }>[] = [];

export function createContext<T, A>(reducer: Reducer<T, A>, contextName: string): React.Context<ContextData<T, A>> {
  const initialState = reducer(undefined, { type: null });
  const Context = React.createContext<ContextData<T, A>>([initialState, (): void => {}]);

  Context.displayName = contextName;
  contextProviders.push(Provider);
  return Context;

  function Provider({ children }: { children: React.ReactElement }): React.ReactElement {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    return <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>;
  }
}

function ContextProvider({ children }: { children: React.ReactElement }): React.ReactElement {
  return contextProviders.reduceRight(
    (acc: React.ReactElement, Provider: React.ComponentType<{ children: React.ReactElement }>): React.ReactElement => (
      <Provider>{acc}</Provider>
    ),
    children
  );
}

export default ContextProvider;
